import React from 'react';
import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { PapiUser, PapiGallection } from '@wix/da-papi-types';
import EditConfigButton from '../../../UserWidgets/_partials/WidgetEditControls/EditConfigButton';
import MediaManager from '@wix/da-shared-react/pkg/MediaPopup/MediaManager';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/basicActions';
import {
  ModalType,
  ModalOptions,
} from '@wix/da-shared-react/pkg/Modals/redux/types';
import { GallectionType } from '../../../../../types/gallection';
import { AppState } from '../../../../../types/store';
import { MediaSourceType } from '@wix/da-shared-react/pkg/MediaPopup/types';
import {
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../../../selectors/users';
import { getGallectionSectionType } from '../../../../selectors/gallectionSection';

interface Props {
  gallectionType: GallectionType;
  profileOwnerUser: PapiUser;
  isCurrentUserProfileOwner: boolean;
  gallection?: PapiGallection;
  className?: string;
  pushModal: (type: ModalType, options: ModalOptions) => void;
}

interface State {
  showMediaManager: boolean;
  isReloading: boolean;
}

const defaultState = {
  showMediaManager: false,
  isReloading: false,
};

class EditGallectionButton extends React.Component<Props, State> {
  state: State = defaultState;
  render() {
    if (!this.props.isCurrentUserProfileOwner) {
      return null;
    }
    return (
      <>
        <EditConfigButton
          className={this.props.className}
          onClick={() => this.setState({ showMediaManager: true })}
        />
        {this.state.showMediaManager && (
          <MediaManager
            initialMediaSource={
              this.props.gallectionType === 'gallery'
                ? MediaSourceType.GALLERY
                : MediaSourceType.COLLECTION
            }
            gallectionFolder={this.props.gallection}
            onClose={this.closeAndReload}
            onDone={this.closeAndReload}
          />
        )}
      </>
    );
  }
  closeAndReload = event => {
    this.setState({
      showMediaManager: false,
      isReloading: true,
    });
    this.props.pushModal(ModalType.LOADING_SCREEN, { wrapInModal: false });
    event && event.preventDefault();

    // Pressing ESC key to close the MM cancels the reload.
    // Let's postpone it by 1 cycle
    setTimeout(() => {
      // This should be a simple reload, but that
      // doesn't set the referrer on Firefox
      // eslint-disable-next-line no-self-assign
      window.location.href = window.location.href;
    }, 1);
  };
}

type StateProps = Pick<
  Props,
  'gallectionType' | 'profileOwnerUser' | 'isCurrentUserProfileOwner'
>;
type DispatchProps = Pick<Props, 'pushModal'>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  gallectionType: getGallectionSectionType(state),
  profileOwnerUser: getProfileOwnerUser(state),
  isCurrentUserProfileOwner: isCurrentUserProfileOwner(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  pushModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditGallectionButton);
